// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rating-stars[data-v-7fd08956]{display:flex}.rating-stars__item-icon[data-v-7fd08956]{color:#fbbf24;font-size:.65em}@media(min-width:1600px){.rating-stars__item-icon[data-v-7fd08956]{font-size:1.3em}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
